<div mat-dialog-title class="dialog-header">
    <span>Confirmation suppression</span>
</div>

<mat-dialog-content class="dialog-content">
    <p>{{ confirmMessage }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="accent-button" (click)="close()">Non</button>
    <button mat-raised-button class="accent-button" (click)="save()">Oui</button>
</mat-dialog-actions>